var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeakerSirenAlarm({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#FFFFFF;stroke-width:0.25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 2.4,
    y: 6.3,
    className: "st0",
    width: 2.8,
    height: 3.5
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "5.2,9.7 13.6,15.5 13.6,0.5 5.2,6.3  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeakerSirenAlarm);
export default __webpack_public_path__ + "static/media/SpeakerSirenAlarm.7e8cdf161be07e0adbcee1f4bb020a2d.svg";
export { ForwardRef as ReactComponent };